import styled from 'styled-components';

export default styled.a`
  font-weight: bold;
  color: inherit !important;
`;
